import React, { useState } from "react";
import styles from "../Casefile.module.scss";
import CloseButton from "./CloseButton";

import { Link } from "@reach/router";

function Cabbage(props) {
  const [bacteriaNo, setBacteriaNo] = React.useState(0);

  if (bacteriaNo === 0) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            You find yourself looking for some Plant Folks in some allotments.
            And you find a big one!
          </p>
          <p>
            "I am Cabbage. I am planted in the winter. I am a hardy vegetable,
            very dependable and very tasty.
          </p>

          <p>
            {" "}
            <button
              onClick={(event) => {
                setBacteriaNo(1);
              }}
            >
              My cabbage "heart"
            </button>
          </p>
          <p>
            {" "}
            is ready to pick in the following spring. I am versatile. I feed
            humans and I feed insects. I have{" "}
          </p>
          <p>
            <button
              onClick={(event) => {
                setBacteriaNo(3);
              }}
            >
              pretty yellow flowers.
            </button>
          </p>
          <p>
            {" "}
            But if you pick them and put them in a vase indoors they smell
            awful!
          </p>

          <p>Help us make some points so we can defend ourselves."</p>
          <p>
            <button
              onClick={(event) => {
                setBacteriaNo(2);
              }}
            >
              POINTS?
            </button>
          </p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 1) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>The cabbage heart is the bit that </p>
          <p>
            <button
              onClick={(event) => {
                setBacteriaNo(2);
              }}
            >
              humans eat.
            </button>
          </p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 2) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            "Humans can boil my cabbage heart, or they can shred my cabbage
            leaves and fry them like seaweed in a Chinese Restaurant.
          </p>

          <p>Some even put mustard on me. Eww.</p>

          <p>
            Protect my heart, create Incident Markers so my story can be known.
          </p>

          <p>
            Every marker scores at least 1 point for the Plant Folk. The better
            you tell my story, the more points they will give us... Protect my
            heart!"
          </p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 3) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            {" "}
            <button
              onClick={(event) => {
                setBacteriaNo(4);
              }}
            >
              Good to look at
            </button>
          </p>{" "}
          <p>but </p>
          <p>
            {" "}
            <button
              onClick={(event) => {
                setBacteriaNo(7);
              }}
            >
              horrible to sniff at.
            </button>
          </p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 4) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            "My yellow flowers hide a surprise for when humans get too close.
          </p>
          <p>But Bees and Flies love my flowers.</p>
          <p>
            The Insect Folk we like, what a shame we have to destroy them in the
            Tournament"
          </p>
          <p>
            {" "}
            <button
              onClick={(event) => {
                setBacteriaNo(5);
              }}
            >
              Tournament?{" "}
            </button>
          </p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 5) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>
            ""Bees and flies land on my flowers and pollinate the{" "}
            <button
              onClick={(event) => {
                setBacteriaNo(6);
              }}
            >
              next generation.{" "}
            </button>
          </p>

          <p>But when it comes to competition we need to win.</p>

          <p>There's a secret Tournament taking place in Liverpool.</p>

          <p>Placing Incident Markers gives us a better chance to be heard."</p>
          <p></p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 6) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>"Little cabbagelets. Aww!!</p>
          <p>My biological clock is ticking.</p>
          <p>I better earn points fast."</p>
          <p>
            <button
              onClick={(event) => {
                setBacteriaNo(1);
              }}
            >
              POINTS?.
            </button>
          </p>
        </div>
      </div>
    );
  }
  if (bacteriaNo === 7) {
    return (
      <div className={styles.queryBox}>
        <CloseButton setSelected={props.setSelected} />
        <div className={styles.questions}>
          <p>"Sniff, sniff, sniff, attchooo!</p>
          <p>Sorry, this allergy to other folk is cooking me.</p>
          <p>We really need your help getting some points."</p>
          <p>
            <button
              onClick={(event) => {
                setBacteriaNo(1);
              }}
            >
              POINTS?.
            </button>
          </p>
        </div>
      </div>
    );
  }
}

export default Cabbage;
